import React, { ReactNode } from "react";
import CarrinhoItemModel from "../model/CarrinhoItemModel";
import ProdutoModel from "../model/ProdutoModel";
import AppState from "../model/AppState";
import Produto from "../Produto";
import CarrinhoModel from "../model/CarrinhoModel";
import NavegadorUtil from "../util/NavegadorUtil";
import LojaModel from "../model/LojaModel";
import ModalMaioridade from "./ModalMaioridade";

type RodapeProdutoProps = {
  produto: ProdutoModel,
  observacao?: string,
  children?: ReactNode,
  parent: Produto,
  fm?: number,
};

type RodapeProdutoState = {
  modalMaioridadeVisivel: boolean;
};

class RodapeProduto extends React.Component<RodapeProdutoProps, RodapeProdutoState> {

  constructor(props: RodapeProdutoProps) {
    super(props);

    this.addItemCarrinho = this.addItemCarrinho.bind(this);
    this.remItemCarrinho = this.remItemCarrinho.bind(this);
    this.hideMaioridade = this.hideMaioridade.bind(this);

    this.state = {
      modalMaioridadeVisivel: false,
    };
  }

  async addItemCarrinho(): Promise<void> {
    const { parent, produto, fm, observacao } = this.props;
    const loja : LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      const msg = "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física.";
      NavegadorUtil.alerta(parent, msg);
    } else {
      const requerMaioridade = await ProdutoModel.requerMaioridade(produto);
      
      if (requerMaioridade && AppState.getMaioridade() !== true) {
        this.setState({ modalMaioridadeVisivel: true });
      } else {
        if (fm) {
          produto.fatorMultiplicacao = +fm;
        }

        await AppState.addCarrinhoItem(produto, observacao).then(c => {
          NavegadorUtil.alerta(parent, AppState.carrinhoMensagem(produto.produtoId));
        }).catch(err => {
          NavegadorUtil.alerta(parent, err.replace(/\\n/, " "));
        });
      }
    }
  }

  async remItemCarrinho(): Promise<void> {
    const {parent, observacao, produto, fm} = this.props;
    
    const loja : LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      NavegadorUtil.alerta(parent,
        "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física.");
    } else {
      // const requerMaioridade = await ProdutoModel.requerMaioridade(produto);

      // if (requerMaioridade && AppState.getMaioridade() !== true) {
      //   this.setState({ modalMaioridadeVisivel: true });
      // } else {
      //   if (fm) {
      //     produto.fatorMultiplicacao = +fm;
      //   }
      //   await AppState.decCarrinhoItem(produto, observacao);
      //   NavegadorUtil.alerta(parent, AppState.carrinhoMensagem(produto.produtoId));
      // }

      if (fm) {
        produto.fatorMultiplicacao = +fm;
      }
      await AppState.decCarrinhoItem(produto, observacao);
      NavegadorUtil.alerta(parent, AppState.carrinhoMensagem(produto.produtoId));
    }
  }

  hideMaioridade(): void {
    const { parent } = this.props;

    this.setState({ modalMaioridadeVisivel: false });
    if (AppState.getMaioridade() === false) {
      NavegadorUtil.alerta(parent, "Este produto requer maioridade.");
    } else {
      this.addItemCarrinho();
    }
  }

  render(): any {
    const { modalMaioridadeVisivel } = this.state;
    const produto: ProdutoModel = this.props.produto;
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const item: CarrinhoItemModel | undefined = carrinho.carrinhoItens
      .find((c: CarrinhoItemModel) => c.produto.produtoId === this.props.produto.produtoId);

    let prodPreco: number = produto.precoDesconto, qtd: number = 0;

    if (item) {
      qtd = item.quantidade;
      if (item.produto.unidade === "GR") {
        prodPreco = prodPreco / 1000 * item.produto.fatorMultiplicacao;
      }
    }

    return (
      <>
        <footer className="product-menu">
          <p className="price">{`R$ ${(prodPreco * qtd).toFixed(2).replace(".", ",")}`}</p>
          <div className="items">
            <button className="remove" onClick={ this.remItemCarrinho }>-</button>
            <div className="qty">{qtd}</div>
            <button className="add" onClick={ this.addItemCarrinho }>+</button>
          </div>
        </footer>
        { modalMaioridadeVisivel &&
        <ModalMaioridade visivel={true} save={this.hideMaioridade} />
        }
      </>
    );
  }
}

export default RodapeProduto;